"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigateWithReset = exports.pushRoute = exports.navigateWithClear = exports.goToRoute = exports.goBack = exports.navigationRef = void 0;
const native_1 = require("@react-navigation/native");
const react_native_1 = require("react-native");
/** @description This shouldn't be used directly. It will affect globally **/
exports.navigationRef = (0, native_1.createNavigationContainerRef)();
function goBack() {
    exports.navigationRef.goBack();
}
exports.goBack = goBack;
/** @description Navigate to an existing Micro-frontend Page initially created by routeMap **/
function goToRoute(name, params, shouldPush = false) {
    react_native_1.Keyboard.dismiss();
    if (exports.navigationRef.isReady()) {
        console.log("CURRENT ROUTE ID IS", name);
        try {
            console.log("In the navigation block");
            !shouldPush ? exports.navigationRef.navigate(name, params) : pushRoute(name, params);
        }
        catch (e) {
            console.log("Error is navigation $$$$$$$", e);
        }
        //pushRoute(name, params);
    }
    else {
        console.log("Error is in navigation");
    }
}
exports.goToRoute = goToRoute;
function navigateWithClear(name, params, shouldPush = false) {
    react_native_1.Keyboard.dismiss();
    if (exports.navigationRef.isReady()) {
        console.log("CURRENT ROUTE ID IS", name);
        try {
            console.log("In the navigation block");
            exports.navigationRef.dispatch(native_1.StackActions.replace(name, params));
        }
        catch (e) {
            console.log("Error is navigation $$$$$$$", e);
        }
        //pushRoute(name, params);
    }
    else {
        console.log("Error is in navigation");
    }
}
exports.navigateWithClear = navigateWithClear;
/** @description create a new Micro-frontend page with new props.
 *  @function pushRoute use to create dynamic new route with new props
 *  @param args accepts  as routeId, props **/
function pushRoute(...args) {
    if (exports.navigationRef.isReady()) {
        try {
            exports.navigationRef.dispatch(
            // @ts-ignore
            native_1.StackActions.push(...args));
        }
        catch (e) {
            console.log(`*** error in navigation: ${e}`);
        }
    }
}
exports.pushRoute = pushRoute;
function navigateWithReset(name, params) {
    exports.navigationRef.reset({
        index: 0,
        routes: [{ name: name, params: params }],
    });
}
exports.navigateWithReset = navigateWithReset;
//# sourceMappingURL=root_navigation.js.map